import type { Collection } from "@shopify/hydrogen-react/storefront-api-types";
import { useQuery } from "react-query";
import { Grid, Link, LoadingSpinner, Stack, UnexpectedError } from "atoms";
import { Image } from "@shopify/hydrogen-react";
import { client } from "../api/client";

const getCollections = () =>
  client.query<{
    collections: { nodes: Partial<Collection>[] };
  }>(`#graphql
  query FeaturedCollections {
    collections(first: 3) {
      nodes {
        id
        title
        handle
      }
    }
  }
`);

function CollectionList() {
  const { data, error, isError } = useQuery(["collections"], getCollections, {
    select: (resp) => resp.collections.nodes,
  });

  if (data) {
    return (
      <>
        <h2>Collections</h2>

        <Grid>
          {data.map(({ id, title, handle, image }) => (
            <div key={id}>
              <Link to={`collections/${handle}`}>
                <Stack>
                  <Image src={image?.url} />
                  {title}
                </Stack>
              </Link>
            </div>
          ))}
        </Grid>
      </>
    );
  }

  if (isError) {
    return <UnexpectedError error={error} />;
  }

  return <LoadingSpinner />;
}

export { CollectionList };
